<template>

    <div id="virtual-image">

        <div class="content-slider" v-if="paginaIndex == 'categorias' && getPageIndex == false ">

             <ResponsiveSlide 
                :title=tryonTraducciones.tryon_elige_una_categoria
                :categoriesVisibles="categoriesVisibles" 
                :list="getCates.cat" 
                :hasBack="categoriaIndex.length > 0"
                tag="cat" 
                @on-tap="clickCat" 
                @on-back="clickBack"
            >

                <template slot="title">
                    <div class="slider-loop">
                        <div class="loop-img icon-back"><div class="icon-back-img"><img :src="baseURL+'img/arrow-back.png'" /></div></div>
                        <div class="loop-title">{{tryonTraducciones.tryon_volver}}</div>
                    </div>
                </template>

                <template slot="list" slot-scope="props">
                    
                    <div class="slider-loop">
                        <div class="loop-img"><img :src="props.item.image_path_circulo"/></div>
                        <div class="loop-title">{{props.item.nombre}}</div>
                    </div>

                </template>


            </ResponsiveSlide> 

            <div class="bar-black"></div>

            <ResponsiveSlide v-if="getCates.prod.length > 0" :title="tryonTraducciones.tryon_elige_un_producto" :list="getCates.prod" tag="prod" @on-tap="clickProd" >
                <template slot="list" slot-scope="props">
                    <div class="slider-loop">
                        <div class="loop-img"><img :src="props.item.image_path_cabecera"/></div>
                    </div>
                </template>
            </ResponsiveSlide>

        </div>

        <CamaraGaleria v-if="paginaIndex == 'camaraGaleria'" @on-camera="clickCamera" @on-input="inputIMG" />

        <CameraApp v-if="paginaIndex == 'cameraapp'" :producto="getCates.prodGet" @on-imgCapture="imgCapture" />

        <VirtualEditor v-if="paginaIndex == 'virtualeditor'" :imgEditor64="imgEditor64" :producto="getCates.prodGet" @on-capture="onCapture" />

        <SharePage v-if="paginaIndex == 'sharepage'" @on-setIndex="setIndex" :producto="getCates.prodGet" :imgSave64="imgSave64" />

    </div>
    
</template>

<script>

    import CamaraGaleria from './components/CamaraGaleria'
    import ResponsiveSlide from './components/responsiveSlide'
    import VirtualEditor from './components/VirtualEditor'
    import CameraApp from './components/CameraApp'
    import SharePage from './components/SharePage'

    console.log(tryon)
    console.log( productoSeleccionado )
    console.log(baseURL)
    console.log('-----', tryonTraducciones )

    export default {

        name: 'app',
        components:{
            CamaraGaleria,
            ResponsiveSlide,
            VirtualEditor,
            CameraApp,
            SharePage,
        },
        data () {
            return {
                baseURL: baseURL,
                paginaIndex: 'categorias',

                categoriaIndex: [],
                productoIndex: 0,
                productoID: null,
                imgEditor64: null,
                imgSave64: null,
                tryon: tryon,
                tryonTraducciones
            }

        },
        mounted: function(){

            if(productoSeleccionado){

                this.paginaIndex = 'camaraGaleria'

            }

        },
        methods: {
            setIndex: function(paginaIndexNew){
                this.paginaIndex = paginaIndexNew
            },
            clickCat: function(index){

                this.categoriaIndex.push(index)

            },
            clickBack: function(){

                this.categoriaIndex.splice(-1,1) 

            },
            clickProd: function(index, { id } ){

                this.paginaIndex = 'camaraGaleria'
                this.productoIndex = index
                this.productoID = id

            },
            inputIMG: function(imgEditor64){

                this.imgEditor64 = imgEditor64
                this.paginaIndex = 'virtualeditor'

            },
            clickCamera: function(){

                this.paginaIndex = 'cameraapp'

            },
            imgCapture: function(img64){
                
                this.imgEditor64 = img64
                this.paginaIndex = 'virtualeditor'

            },
            onCapture: function(dataUrl){

                this.imgSave64 = dataUrl
                this.paginaIndex = 'sharepage'

            }
        },
        computed: {

            getPageIndex: function(){

                if(productoSeleccionado) return true

                return false

            },

            getCates: function(){
                
                if(productoSeleccionado){

                    return { cat:[], prod:[], prodGet: productoSeleccionado }

                }else{

                    if(this.categoriaIndex.length <= 0){

                        cat = getFilterCates(this.tryon, categoriesVisibles)

                        return { cat: cat, prod: [] }

                    }
                    
                    let cat = this.tryon
                    let prod = null

                    this.categoriaIndex.forEach(index => {

                        const memo = cat[index]
                        cat = memo.categorias
                        prod = memo.productos

                    })

                    cat = getFilterCates(cat, categoriesVisibles)

                    return { cat, prod, prodGet: prod[this.productoIndex] }

                }

            }

        }
    }


    function getFilterCates(list, filter){

        return list.filter(function(item){

            if( filter.indexOf(Number(item.id)) != -1 ){
                return true
            }else{
                return false
            }
        })

    }

</script>

<style lang="scss">

    #virtual-image {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        // background: #e8ebec;
        padding: 0.015629px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-height: 600px;

        .virtual-image-title{
            margin-top: 20px;
            font-size: 18px;
            color: #b6b6b6;
            text-transform: uppercase;
        }

         .circle-btn{
            border: 3px solid white;
            padding: 10px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 100px;
            margin: auto;
            background: linear-gradient(-180deg,#0dfae3 20%,#4ee3fa 80%);
            box-shadow: 0 3px 6px rgba(0,0,0,.16), 0 3px 6px rgba(0,0,0,.23);

            img{ max-width: 56px; }

            &:hover{

                background: linear-gradient(-180deg,#fc3740 20%,#f3307a 80%);

            }

        }

    }

    .cat{

        .loop-img:not(.icon-back){
                
            &:hover{
                background: linear-gradient(-45deg,#fa3d3e 20%,#ef3e8b 80%);
                border: 0;

                img{
                    transform: scale(1.3);
                }

            }
        
        }
        
    }
    
    .prod{

        .loop-img:not(.icon-back){
                
            &:hover{
                background: linear-gradient(-45deg,#00e0c5 20%,#4ee3fa 80%);
                border: 0;

                img{
                    transform: scale(1.3);
                }

            }
        
        }

    }

    .content-slider {

        width: 90%;
        max-width: 580px;

        .slider-loop{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;

            .loop-img{
                border-radius: 50%;
                overflow: hidden;
                width: 21vw;
                height: 21vw;
                min-width: 100px;
                min-height: 100px;
                max-width: 120px;
                max-height: 120px;
                background: #f7f7f7;

                box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
                border: 2px solid;
                
                display: flex;
                justify-content: center;
                align-items: center;

                img{
                    transition: all .5s ease-in-out;
                    pointer-events: none;
                    width: 100%;
                }


            }
            

            // .loop-img:not(.icon-back){
                
            //     &:hover{
            //         background: linear-gradient(-45deg,#fa3d3e 20%,#ef3e8b 80%);
            //         border: 0;

            //         img{
            //             transform: scale(1.3);
            //         }

            //     }
           
            // }

            .icon-back{
                display: flex;
                justify-content: center;
                align-items: center;
    

                .icon-back-img{
                    
                    transition-duration: 0.8s;
                    transition-property: transform;

                    &:hover{

                        transform:rotate(-360deg) translate3d( 0, 0, 0);
                        
                    }
                  

                }

                img{
                    width: 100%;
                }

            }

        }

        .loop-title{
            line-height: 25px;
            color: #102747;
            font-size: 13px;
        }

    }


    


</style>



// WEBPACK FOOTER //
// src/App.vue